import { tryCatchHelper } from '../../../helpers';
import { AJUSTES_ENTIDADES } from '../../entidad/entidades/EntidadesReducer';
import { LOADING_GETONE_ENT_AJUSTES } from './EntAjustesReducer';
import {
  oneEntAjustesService,
  saveEntAjustesService,
} from './EntAjustesService';

export const saveEntAjustesAction = async ({ dispatch, notify }, data) => {
  try {
    const res = await saveEntAjustesService(data);
    notify(res.data.message);
    setActivoEntAjustesAction(dispatch, res.data.data);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoEntAjustesAction = async (dispatch, data) => {
  dispatch({ type: AJUSTES_ENTIDADES, payload: data });
};

export const oneEntAjustesAction = async (dispatch, id) => {
  try {
    dispatch({ type: LOADING_GETONE_ENT_AJUSTES, payload: true });
    const res = await oneEntAjustesService(id);
    setActivoEntAjustesAction(dispatch, res.data.data);
    dispatch({ type: LOADING_GETONE_ENT_AJUSTES, payload: false });
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};
